export default () => {
  const accordionButtons = document.querySelectorAll(
    '.c-accordion [role="button"]',
  );

  [].forEach.call(accordionButtons, button => {
    const accordion = button.parentNode;
    const container = accordion.querySelector('.c-accordion__content');
    const content = accordion.querySelector('.c-accordion__content-inner');

    button.addEventListener('click', event => {
      event.preventDefault();
      container.style.maxHeight = `${content.scrollHeight}px`;

      if (accordion.classList.contains('active')) {
        // eslint-disable-next-line
        container.offsetHeight;
        container.removeAttribute('style');
      }

      accordion.classList.toggle('active');
    });

    container.addEventListener('transitionend', () => {
      if (accordion.classList.contains('active')) {
        container.removeAttribute('style');
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/accordions.js